/**
 * @file Helper functions for eletters.
 */

/**
 * Processes user-provided text to a child by:
 * - Trimming whitespace from start and end
 * - Collapsing multiple (>2) newlines into double newlines
 *
 * @param text - The text to process
 * @returns The processed text
 */
export function processSponsorMessage(text: string): string {
  if (!text) return "";
  return text.trim().replace(/\n{3,}/g, "\n\n");
}
